module.exports = __webpack_public_path__ + "media/images/billing/agendor-integracao-token-dc1ad05662b235c376e80ae47d391ac2.gif";